import { render, staticRenderFns } from "./ScalarValuesTable.vue?vue&type=template&id=588b3ce9&scoped=true&"
import script from "./ScalarValuesTable.vue?vue&type=script&lang=js&"
export * from "./ScalarValuesTable.vue?vue&type=script&lang=js&"
import style0 from "./ScalarValuesTable.vue?vue&type=style&index=0&id=588b3ce9&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "588b3ce9",
  null
  
)

export default component.exports